/**
 * @file jobs.ts
 *
 * @fileoverview Include routes for the jobs.
 */
const jobiqoJobsConfig = require('./../jobs');
const R = require('ramda');

module.exports = R.mergeDeepRight(jobiqoJobsConfig, {
  public: {
    ALLOWED_JOB_TYPES: ['job_per_template', 'job_per_link', 'job_per_file'],
    GEO_INFO: {
      fixtures: [],
    },
  },
});
